var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.toolbarStyle && _vm.toolbarStyle.showStyle === 2
    ? _c(
        "div",
        {
          staticStyle: {
            background: "#FFFFFF",
            "border-radius": "10px",
            padding: "8px 5px 0 5px",
          },
        },
        [
          _vm.toolbarStyle &&
          _vm.toolbarStyle.title &&
          _vm.toolbarStyle.showTitle === 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#000000",
                    "font-weight": "bold",
                    "font-size": "13px",
                    "margin-bottom": "6px",
                  },
                },
                [_vm._v(_vm._s(_vm.toolbarStyle.title))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-start",
                "flex-wrap": "wrap",
              },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticStyle: {
                    "text-align": "center",
                    width: "20%",
                    "margin-bottom": "5px",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "25px", height: "25px" },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/icon.png"),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "font-size": "11px" } }, [
                    _vm._v(_vm._s(item.bannerName)),
                  ]),
                  _vm._v(" "),
                  item.bottomDesc
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            color: "#666666",
                            "margin-top": "5px",
                          },
                        },
                        [_vm._v(_vm._s(item.bottomDesc))]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]
      )
    : _c(
        "div",
        {
          staticStyle: {
            background: "#FFFFFF",
            "border-radius": "10px",
            padding: "8px 5px 5px 5px",
          },
        },
        [
          _vm.toolbarStyle &&
          _vm.toolbarStyle.title &&
          _vm.toolbarStyle.showTitle === 1
            ? _c(
                "div",
                {
                  staticStyle: {
                    color: "#000000",
                    "font-weight": "500",
                    "font-size": "13px",
                    "margin-bottom": "5px",
                  },
                },
                [_vm._v(_vm._s(_vm.toolbarStyle.title))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "flex-start",
                "flex-wrap": "wrap",
              },
            },
            _vm._l(_vm.dataList, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  style: {
                    textAlign: "center",
                    width: _vm.toolbarStyle.showStyle === 1 ? "25%" : "33%",
                    marginBottom: "5px",
                  },
                },
                [
                  _c("img", {
                    staticStyle: { width: "30px", height: "30px" },
                    attrs: {
                      src: item.bannerPic
                        ? item.bannerPic
                        : require("@/assets/customPage/icon.png"),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "font-size": "11px" } }, [
                    _vm._v(_vm._s(item.bannerName)),
                  ]),
                  _vm._v(" "),
                  item.bottomDesc
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "10px",
                            color: "#666666",
                            "margin-top": "5px",
                          },
                        },
                        [_vm._v(_vm._s(item.bottomDesc))]
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }